import * as Yup from 'yup'

const productMaterialSchema = Yup.object().shape({
  label: Yup.string().required('Required')
})

export default productMaterialSchema
